import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/providers/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Fira_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"400\",\"variable\":\"--font-fira-sans\"}],\"variableName\":\"fira_sans\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
